import { JSON } from '@common/JSON/JSON'

import { EHttpStatusCode } from '@common/http/definitions'
import type { TRequestMethod } from '@common/http/definitions'

import { EXhrReadyState } from '../consts'

import setCorsOrigin from '../v1/setCorsOrigin'
import getMethod from '../v1/getMethod'

type TCallback = (xhr: XMLHttpRequest) => void

interface IProps {
  /** Hova lőjjük a request-et. */
  readonly url: string
  /** Sikeres válasz esetén hívódó callback. */
  readonly onSuccess: TCallback
  /** Hiba esetén hívódó callback. */
  readonly onError: TCallback
  /** Opcionális adat. */
  readonly data?: TAnyObject | undefined
  /** Opcionális corsOrigin. */
  readonly corsOrigin?: string | undefined
  /** Opcionális header contentType. */
  readonly contentType?: string | undefined
  /** Opcionális request method. */
  readonly method?: TRequestMethod
}

/**
 * Halálegyszerű, pársoros ajax, basic felhasználáshoz.
 * @param props - A lehetséges beállítások.
 */
export default function ajax (props: IProps): void {
  const xhr = new XMLHttpRequest()

  xhr.addEventListener('readystatechange', (): void => {
    if (xhr.readyState === EXhrReadyState.Done) {
      if (xhr.status === EHttpStatusCode.Ok) {
        props.onSuccess(xhr)
      }
      else {
        props.onError(xhr)
      }
    }
  })

  const method = getMethod(props.data ?? null, props.method)
  const body = props.data ? JSON.stringify(props.data) : null

  xhr.open(method, props.url, true)

  // ENNEK AZ OPEN UTÁN KELL LENNIE!
  if (props.corsOrigin) {
    setCorsOrigin(xhr, props.corsOrigin)
  }

  if (props.contentType) {
    xhr.setRequestHeader('Content-type', props.contentType)
    xhr.setRequestHeader('Accept', props.contentType)
  }

  xhr.send(body)
}
